import PropTypes from 'prop-types';
import React from 'react';
import { Book } from 'react-bootstrap-icons';
import GetAppIcon from '@mui/icons-material/GetApp';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ProductDetailItemCard from './ProductDetailItemCard';

function ProductOverviewSection({ product, theme, t, onPrintCardDownload }) {
	const displayValue = (value) => (value == null ? '' : value);
	const isPrintCardSupported = !!product?.PrintCard?.isSupported;

	return (
		<>
			<Grid item xs={12} aria-label={t('products:product_overview')}>
				<Grid container>
					<Grid item xs={12} aria-label={t('products:product_overview')}>
						<Book
							style={{
								fontSize: '1.45rem',
								marginBottom: '-.27rem',
								marginRight: '.49rem',
							}}
							aria-label="Book"
							role="graphics-symbol"
							aria-hidden="true"
						/>
						<Typography
							variant="heading7"
							aria-label={t('products:product_overview')}
							role="paragraph"
						>
							{t('products:product_overview')}
						</Typography>
						<Divider
							sx={{ my: 1 }}
							aria-label={t('products:product_overview')}
							tabIndex={-1}
							role="presentation"
						/>
					</Grid>
				</Grid>
			</Grid>

			<Grid item xs={12}>
				<Grid container>
					<Grid item xs={12}>
						<Grid container>
							<Grid item xs={12}>
								<Grid container spacing={2}>
									<Grid item lg={3} sm={4} xs={12}>
										<ProductDetailItemCard
											name={t('customer_item_number')}
											value={displayValue(product.Customer_Item_Number)}
										/>
									</Grid>
									<Grid item lg={3} sm={4} xs={12}>
										<ProductDetailItemCard
											name={t('sku_number')}
											value={displayValue(product.Design_Number)}
										/>
									</Grid>
									<Grid item lg={3} sm={4} xs={12}>
										<ProductDetailItemCard
											name={t('location')}
											value={displayValue(product.Plant_Name)}
										/>
									</Grid>
									<Grid item lg={3} sm={4} xs={12}>
										<ProductDetailItemCard
											name={t('total_ordered')}
											value={displayValue(product.Quantity_Ordered)}
										/>
									</Grid>
									<Grid item lg={3} sm={4} xs={12}>
										<ProductDetailItemCard
											name={t('total_shipped')}
											value={displayValue(product.Quantity_Shipped)}
										/>
									</Grid>
									{product.Total_Inventory_Qty != null && (
										<Grid item lg={3} sm={4} xs={12}>
											<ProductDetailItemCard
												name={t('Total_Inventory_Qty')}
												value={displayValue(product.Total_Inventory_Qty)}
											/>
										</Grid>
									)}
									<Grid item lg={3} sm={4} xs={12}>
										<Grid
											item
											xs={12}
											role="paragraph"
											aria-label={t('print_card')}
										>
											<Typography
												variant="heading8"
												tabIndex={0}
												aria-label={t('print_card')}
												role="paragraph"
											>
												{t('print_card')}
											</Typography>

											<Grid item xs={6} mt={0.35} role="paragraph">
												{isPrintCardSupported ? (
													<Button
														variant="outlined"
														color="primary"
														size="small"
														endIcon={<GetAppIcon fontSize="small" />}
														onClick={onPrintCardDownload}
														sx={{ minWidth: 100, textTransform: 'none' }}
													>
														{t('common:download')}
													</Button>
												) : (
													<Typography
														variant="caption1"
														tabIndex={0}
														aria-label={t('common:not_available')}
														role="paragraph"
													>
														{t('common:not_available')}
													</Typography>
												)}
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12}>
								<Grid
									container
									direction="row"
									justifyContent="left"
									alignItems="flex-start"
								>
									<Grid item xs={6}></Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}

ProductOverviewSection.propTypes = {
	product: PropTypes.shape({
		Customer_Item_Number: PropTypes.any,
		Design_Number: PropTypes.any,
		Plant_Name: PropTypes.any,
		Quantity_Ordered: PropTypes.any,
		Quantity_Shipped: PropTypes.any,
		Total_Inventory_Qty: PropTypes.any,
		PrintCard: PropTypes.shape({
			fileAvailable: PropTypes.bool,
			fileName: PropTypes.string,
			isSupported: PropTypes.bool,
		}),
	}).isRequired,
	onPrintCardDownload: PropTypes.func.isRequired,
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default ProductOverviewSection;
